// https://app.growthbook.io/features/mccerts-2805_v1
export const MCCERTS_2805_HUB_VALUE_PROP_FLAG = 'mccerts-2805_v1'

export const HUB_HERO_VIDEO = {
  mediaUuid: 'a528cb48-dd8a-4981-938e-bb58edc95a4f',
  fallbackImageUrl:
    'https://static.masterclass.com/certs-hero-fallback-1x1.jpg',
} as const
